import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import { useSeo } from "@/lib/seo";

export default function NotFound() {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;

  useSeo({
    title: `${t("notFound.title")} - CSSBuy Spreadsheet`,
    description: t("notFound.desc"),
    noindex: true,
  });

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />
      <main className="flex-1 flex items-center justify-center px-4">
        <div className="text-center">
          <h1 className="text-9xl md:text-[12rem] font-black text-gray-100 select-none leading-none">
            404
          </h1>
          <div className="relative -mt-12 md:-mt-20">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
              {t("notFound.title")}
            </h2>
            <p className="text-gray-600 mb-8">{t("notFound.desc")}</p>
            <Link
              to={`/${currentLang}`}
              className="inline-flex items-center gap-2 px-6 py-3 bg-emerald-700 text-white font-medium rounded-lg hover:bg-emerald-800 transition-colors"
            >
              <i className="ri-arrow-left-line" />
              {t("notFound.back")}
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}